import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
// import { ApplicationList } from "../../../../core/data/json/applicationList";
import { TableData } from "../../../../core/data/interface";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
// import StudentModals from "../studentModals";
import Table from "../../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import {
  allClass,
  allSection,
  gender,
  names,
  status,
} from "../../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../../core/common/commonSelect";
import TooltipOption from "../../../../core/common/tooltipOption";
import { _get } from "../../../Utils/Helper";

const ApplicationList = () => {
  const _form = {
    search: "",
  };
  const [form, setForm] = useState(_form);

  const navigate = useNavigate();
  const [new_data, setNewData] = useState([]);

  // const handleChange = ({ target: { name, value } }) => {
  //     setForm((p) => ({ ...p, [name]: value }));
  // }

  const getAdmissionList = () => {
    _get(
      "application_list?query_type=select",
      (res) => {
        setNewData(res.data);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    getAdmissionList();
  }, []);

  // const get_admission_number_generatorList = () => {
  //   _get(
  //     `get_admission_number_generator?query_type=select_type_of_school`,
  //     (res) => {
  //       setNewData(res.results);
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // };

  // useEffect(() => {
  //   get_admission_number_generatorList();
  // }, []);

  const routes = all_routes;
  // const data = ApplicationList;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const columns = [
    {
      title: "Application No",
      dataIndex: "applicant_id",
      render: (text: string) => (
        <Link
          to={`${routes.applicantFees}?admission_no=${text}`}
          className="link-primary"
        >
          {text}
        </Link>
      ),
      // sorter: (a: TableData, b: TableData) => a.name.length - b.name.length,
    },

    {
      title: "Name",
      dataIndex: "name_of_applicant",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          {/* <Link to="#" className="avatar avatar-md">
            <ImageWithBasePath
              src={record.imgSrc}
              className="img-fluid rounded-circle"
              alt="img"
            />
          </Link> */}
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#">{text}</Link>
            </p>
          </div>
        </div>
      ),
      // sorter: (a: TableData, b: TableData) => a.name.length - b.name.length,
    },
    {
      title: "Last Class Attended",
      dataIndex: "last_class",
      // sorter: (a: TableData, b: TableData) => a.class.length - b.class.length,
    },
    // {
    //   title: "Section",
    //   dataIndex: "section",
      // sorter: (a: TableData, b: TableData) =>
    //   //   a.section.length - b.section.length,
    // },
    {
      title: "Gender",
      dataIndex: "sex",
      // sorter: (a: TableData, b: TableData) => a.gender.length - b.gender.length,
    },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (text: string) => (
    //     <>
    //       {text === "Active" ? (
    //         <span className="badge badge-soft-success d-inline-flex align-items-center">
    //           <i className="ti ti-circle-filled fs-5 me-1"></i>
    //           {text}
    //         </span>
    //       ) : (
    //         <span className="badge badge-soft-danger d-inline-flex align-items-center">
    //           <i className="ti ti-circle-filled fs-5 me-1"></i>
    //           {text}
    //         </span>
    //       )}
    //     </>
    //   ),
    //   sorter: (a: TableData, b: TableData) => a.status.length - b.status.length,
    // },
    // {
    //   title: "Date of Join",
    //   dataIndex: "DateofJoin",
    //   // sorter: (a: TableData, b: TableData) =>
    //   //   a.DateofJoin.length - b.DateofJoin.length,
    // },
    {
      title: "DOB",
      dataIndex: "date_of_birth",
      // sorter: (a: TableData, b: TableData) => a.DOB.length - b.DOB.length,
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Application List</h3> */}
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Students</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Application
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              <div className="mb-2">
                <Link
                  to={routes.addApplication}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  New Application
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Applications List</h4>
              
            </div>
              {/* {JSON.stringify(new_data)} */}
            <div className="card-body p-0 py-3">
              {/* Student List */}
              <Table
                dataSource={new_data}
                columns={columns}
                Selection={false}
              />
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* <StudentModals /> */}
    </>
  );
};

export default ApplicationList;
